import { schema } from 'normalizr';

const productSchema = new schema.Entity('products', {});

export default productSchema;
